import Vue from 'vue';
import Store from '@app/store';
import Modules from '@app/modules';
import Http from 'axios';
import LoginComponent from '@app/modules/RF/Member/modals/Login.vue';
import RegisterComponent from '@app/modules/RF/Member/modals/Register.vue';
import ProfileComponent from '@app/modules/RF/Member/modals/Profile.vue';
import MenuComponent from '@app/modules/RF/CMS/Menu.vue';
import LanguageSwitchComponent from '@app/components/LanguageSwitch.vue';
// @ts-ignore
import { headroom as Headroom } from 'vue-headroom';
export default Vue.extend({
    components: {
        Headroom: Headroom,
        MenuComponent: MenuComponent,
        LanguageSwitchComponent: LanguageSwitchComponent
    },
    watch: {
        $route: function () {
            Store.Navigation.ACTIONS.close();
        }
    },
    data: function () {
        return {
            navModuleComponents: Modules.getTaggedComponents('nav'),
            iconBarModuleComponents: Modules.getTaggedComponents('iconBar'),
            user: this.$user,
        };
    },
    computed: {
        isNavigationOpen: function () {
            return Store.Navigation.STATE.isOpen;
        },
        navigationItems: function () {
            return Store.Navigation.GETTERS.getFilteredItems();
        },
        languages: function () {
            return Store.STATE.languages;
        }
    },
    methods: {
        toggleNavigation: function () {
            Store.Navigation.ACTIONS.toggle();
        },
        closeNavigation: function () {
            Store.Navigation.ACTIONS.close();
        },
        openNavigation: function () {
            Store.Navigation.ACTIONS.open();
        },
        openLogin: function () {
            this.closeNavigation();
            this.$helpers.modal(this.$root, LoginComponent);
        },
        openRegister: function () {
            this.closeNavigation();
            this.$helpers.modal(this.$root, RegisterComponent);
        },
        openProfile: function () {
            this.closeNavigation();
            this.$helpers.modal(this.$root, ProfileComponent);
        },
        logout: function () {
            var _this = this;
            this.closeNavigation();
            Http.post('/logout').then(function () {
                _this.$user = null;
                _this.user = null;
            });
        },
    }
});
